import { Form } from 'antd';
import PlaylistMedia from '../PlaylistMedia';
import ScreenChannel from '../ScreenChannel';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';
import channelApis from 'modules/channel/services/apis';
import toast from 'utils/toast';
import { getMessageError } from 'services/response';
import { IContentItem } from 'modules/channel/interfaces/api';
import { useEffect } from 'react';

export type FormValues = {
  media?: string;
  link?: string;
  contentItems?: IContentItem[];
  activeZone?: string;
  layoutId?: string;
  channelName?: string;
};

interface ChannelFormProps {
  idChannel?: string;
}
const ChannelForm = ({ idChannel }: ChannelFormProps) => {
  const [form] = Form.useForm<FormValues>();
  const location = useLocation();
  const { layoutId, channelName } = location.state as { layoutId?: string; channelName?: string } || {};
  const navigate = useNavigate();

  const handleSubmit = async (values: FormValues) => {
    try {
      const res = await channelApis.createChannel({
        name: values.channelName || '',
        layoutId: values.layoutId || '',
        resolution: '1920x1080',
        contentItems: values.contentItems || [],
      });

      if (res?.data?.data) {
        toast.success('Channel created successfully');
        navigate('/channel');
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'An error occurred while creating the channel');
    }
  };

  useEffect(() => {
    if (idChannel) {
      const fetchChannelDetail = async () => {
        try {
          const res = await channelApis.getDetailChannel(idChannel);
          if (res?.data?.data) {
            const channelData = res.data.data;
            form.setFieldsValue({
              channelName: channelData.name,
              layoutId: channelData.layoutId,
              contentItems: channelData.contentItems,
            });
          }
        } catch (error) {
          toast.error(getMessageError(error) || 'An error occurred while fetching channel details');
        }
      };

      fetchChannelDetail();
    }
  }, [idChannel, form]);

  return (
    <Container>
      <Form form={form} layout='vertical' className='form-container' onFinish={handleSubmit} initialValues={{
        layoutId: layoutId,
        channelName: channelName,
      }}>
        <Form.Item noStyle name='contentItems' hidden>
          <input type='hidden' />
        </Form.Item>
        <Form.Item noStyle name='channelName' initialValue={channelName}>
          <input type='hidden' />
        </Form.Item>
        <LeftSection>
          <ScreenChannel form={form} idChannel={idChannel}/>
        </LeftSection>
        <RightSection>
          <PlaylistMedia form={form} idChannel={idChannel} />
        </RightSection>
      </Form>
    </Container>
  );
};

export default ChannelForm;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  .form-container {
    display: flex;
    width: 100%;
    height: 100%;
  }
`;

const LeftSection = styled.div`
  flex: 1;
`;
const RightSection = styled.div`
  width: 330px;
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.15);
`;
